/**
 * O que o Assistente responde quando o plano do workspace não o inclui.
 *
 * A porta fica ABERTA de propósito: o campo continua habilitado, a pessoa
 * escreve o pedido e recebe uma resposta. Um aviso seco ("fale com o
 * administrador") não ensina nada — quem nunca usou o Assistente não faz
 * ideia do que está deixando de fazer, e o pedido que a pessoa acabou de
 * digitar é justamente a melhor demonstração possível.
 *
 * Nada disso chama a IA nem o servidor: o texto é montado aqui, no
 * navegador. O `/api/assistente/stream` continua recusando com 403 — este
 * módulo é vitrine, não uma porta dos fundos.
 */

export const BENEFICIOS = [
  "Cria e agenda campanhas de WhatsApp e e-mail conversando — sem abrir cinco telas.",
  "Monta fluxos, automações e modelos de mensagem a partir de uma frase sua.",
  "Responde sobre o funil, os contatos e os resultados lendo os dados do seu workspace.",
  "Trabalha na tela em que você está: reescreve o e-mail aberto, redige a resposta do atendimento.",
  "Ensina como se faz, com os botões prontos para você clicar e resolver.",
  "Aceita print, documento e áudio — e age sempre dentro das suas permissões.",
] as const;

/** Pedido longo demais vira um trecho: a resposta é uma vitrine, não um eco. */
function trecho(pedido: string): string {
  const limpo = pedido.trim().replace(/\s+/g, " ");
  if (limpo.length <= 120) return limpo;
  return `${limpo.slice(0, 120)}…`;
}

/**
 * A resposta de vitrine. Cita o pedido para que a demonstração seja sobre o
 * trabalho da pessoa, e não um folheto genérico.
 */
export function respostaDePropaganda(pedido: string): string {
  const p = trecho(pedido);
  const abertura = p
    ? `Eu resolveria **“${p}”** para você agora — mas o Assistente ainda não está incluído no plano deste workspace.`
    : "O Assistente ainda não está incluído no plano deste workspace.";

  return [
    abertura,
    "",
    "**O que eu faço quando estou liberado:**",
    ...BENEFICIOS.map((b) => `- ${b}`),
    "",
    "Liberar é uma troca de plano — nada para instalar, e o histórico já começa aqui.",
  ].join("\n");
}
